import { Controller } from "react-hook-form";
import { FormattedMessage, useIntl } from "react-intl";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { normalizeEgyptMobile } from "../utils";

export default function SubscribePhoneField({
  control,
  errors,
  selectedPhoneCountry,
  setSelectedPhoneCountry,
  setError,
  clearErrors,
}) {
  const intl = useIntl();

  return (
    <div className="form-label row">
      <div className="col-xl-4 col-lg-3">
        <label>
          <FormattedMessage id="mobile" />:
        </label>
      </div>
      <div className="col-xl-8 col-lg-9">
        <div className="row">
          <div className="col-lg-12 position-relative">
            <div
              className={`form-label-container mobile ${
                errors?.mobile?.message ? "mb-3" : ""
              }`}
              dir="ltr"
            >
              <Controller
                control={control}
                name="mobile"
                render={({ field: { ref, ...field } }) => (
                  <PhoneInput
                    name={field.name}
                    value={field.value || ""}
                    onChange={(value, countryData) => {
                      const digits = String(value || "").replace(/\D/g, "");
                      const dialCode = String(countryData?.dialCode || "");
                      const countryCode = String(
                        countryData?.countryCode || selectedPhoneCountry,
                      );
                      setSelectedPhoneCountry(countryCode);

                      const localNumber =
                        countryCode === "eg"
                          ? digits.startsWith(dialCode || "20")
                            ? digits.slice((dialCode || "20").length)
                            : normalizeEgyptMobile(digits)
                          : digits;

                      if (countryCode === "eg" && localNumber.length > 11) {
                        setError("mobile", {
                          type: "manual",
                          message: intl.formatMessage({
                            id: "egypt-mobile-validation",
                          }),
                        });
                        return;
                      }

                      clearErrors("mobile");
                      field.onChange(digits);
                    }}
                    country="eg"
                    inputProps={{
                      ref,
                      required: true,
                      autoFocus: true,
                      onKeyDown: (e) => {
                        const allowedKeys = [
                          "Backspace",
                          "Delete",
                          "ArrowLeft",
                          "ArrowRight",
                          "Tab",
                          "Home",
                          "End",
                          "Control",
                          "Meta",
                          "Alt",
                          "Shift",
                        ];
                        const isDigit = /^[0-9]$/.test(e.key);
                        if (e.ctrlKey || e.metaKey) {
                          return;
                        }
                        const currentDigits = String(field.value || "").replace(
                          /\D/g,
                          "",
                        );
                        const localLength = currentDigits.startsWith("20")
                          ? currentDigits.length - 2
                          : normalizeEgyptMobile(currentDigits).length;
                        if (
                          isDigit &&
                          selectedPhoneCountry === "eg" &&
                          localLength >= 11
                        ) {
                          e.preventDefault();
                          setError("mobile", {
                            type: "manual",
                            message: intl.formatMessage({
                              id: "egypt-mobile-validation",
                            }),
                          });
                          return;
                        }
                        if (
                          !isDigit &&
                          !allowedKeys.includes(e.key) &&
                          !(e.ctrlKey || e.metaKey)
                        ) {
                          e.preventDefault();
                        }
                      },
                    }}
                    inputStyle={{
                      direction: "ltr",
                    }}
                    placeholder="+201121221501"
                    className={`form-control ${
                      errors.mobile ? "is-invalid px-4" : ""
                    }`}
                  />
                )}
              />
            </div>
            <span
              className="position-absolute"
              style={{
                top: "10px",
                insetInlineEnd: "0px",
                color: "red",
              }}
            >
              *
            </span>
          </div>
        </div>
        <div className="col-12 mb-3">
          {errors?.mobile?.message && (
            <div role="alert" className="alert alert-danger py-1">
              {errors.mobile.message}
            </div>
          )}
        </div>
        <div className="col-12">
          {errors?.countryCode?.message && (
            <div role="alert" className="alert alert-danger py-1">
              {errors.countryCode.message}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
